import React from 'react';
import { PayloadStates } from '@lore/utils';
import MetricLoader from '../../MetricLoader';
import moment from 'moment-timezone';
import ComparisonMetric from '../../ComparisonMetric';
import useEducatorEvaluationsCreated from './useEducatorEvaluationsCreated';

export default function EducatorEvaluationsCreated(props) {
  const { network, schoolStart, schoolEnd, titleOnly = false } = props;

  const title = `(den) # educator evals created`;

  const previousSchoolStart = moment(schoolStart).subtract(1, 'year').toISOString();

  const previousUsers = useEducatorEvaluationsCreated(network, {
    start: titleOnly ? undefined : previousSchoolStart,
    end: schoolStart
  });

  const newUsers = useEducatorEvaluationsCreated(network, {
    start: schoolStart,
    end: schoolEnd
  });

  if (
    previousUsers.state === PayloadStates.FETCHING ||
    newUsers.state === PayloadStates.FETCHING
  ) {
    return (
      <MetricLoader
        name={title}
      />
    );
  }

  return (
    <ComparisonMetric
      name={title}
      value={newUsers.meta.totalCount}
      previousValue={previousUsers.meta.totalCount}
      titleOnly={titleOnly}
    />
  );
}
